module.exports = __webpack_public_path__ + "static/media/brew-busd.a1e5c312.svg";